var map = {
	"./Average.svg": "./src/assets/images/svg/components/Average.svg",
	"./Edit.svg": "./src/assets/images/svg/components/Edit.svg",
	"./Filter.svg": "./src/assets/images/svg/components/Filter.svg",
	"./Fixed-amount.svg": "./src/assets/images/svg/components/Fixed-amount.svg",
	"./Search.svg": "./src/assets/images/svg/components/Search.svg",
	"./TableCellTruncatedText": "./src/assets/images/svg/components/TableCellTruncatedText.vue",
	"./TableCellTruncatedText.vue": "./src/assets/images/svg/components/TableCellTruncatedText.vue",
	"./Transactions.svg": "./src/assets/images/svg/components/Transactions.svg",
	"./Trending-Down.svg": "./src/assets/images/svg/components/Trending-Down.svg",
	"./Trending-UP.svg": "./src/assets/images/svg/components/Trending-UP.svg",
	"./Users.svg": "./src/assets/images/svg/components/Users.svg",
	"./circle_rolling_animation.svg": "./src/assets/images/svg/components/circle_rolling_animation.svg",
	"./copy-clipboard.svg": "./src/assets/images/svg/components/copy-clipboard.svg",
	"./cross-x.svg": "./src/assets/images/svg/components/cross-x.svg",
	"./filters_popup.svg": "./src/assets/images/svg/components/filters_popup.svg",
	"./no_brand_logo.svg": "./src/assets/images/svg/components/no_brand_logo.svg",
	"./report_tx_icon.svg": "./src/assets/images/svg/components/report_tx_icon.svg",
	"./right-arrow.svg": "./src/assets/images/svg/components/right-arrow.svg",
	"./sort-arrow.svg": "./src/assets/images/svg/components/sort-arrow.svg",
	"./sort_down.svg": "./src/assets/images/svg/components/sort_down.svg",
	"./sort_normal.svg": "./src/assets/images/svg/components/sort_normal.svg",
	"./sort_up.svg": "./src/assets/images/svg/components/sort_up.svg",
	"./users-sm.svg": "./src/assets/images/svg/components/users-sm.svg",
	"./v-line-md.svg": "./src/assets/images/svg/components/v-line-md.svg",
	"./v-line-sm.svg": "./src/assets/images/svg/components/v-line-sm.svg",
	"./x.svg": "./src/assets/images/svg/components/x.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/svg/components sync recursive ^\\.\\/.*$";